export default "__VITE_ASSET__CmYen2Fo__"